(async () => {

  if (!customElements.get('product-card')) {

    class ProductCard extends HTMLElement {
      constructor() {
        super();

        // Selectors
        this.productWishlist = this.querySelector('.iWishAddColl');
        this.productUrls = this.querySelectorAll('[data-product-href]');
        this.productTitles = this.querySelectorAll('[data-product-title]');
        this.productShortDescriptions = this.querySelectorAll('[data-product-short-description]');
        this.productPrices = this.querySelectorAll('[data-product-price]');
        this.productCompareAtPricesMax = this.querySelectorAll('[data-product-compare-at-price-max]');
        this.productFeaturedImage = this.querySelector('[data-product-featured-image]');

        // Loader for variants on the collection (when the product card is using the parameter with_js = true)
        this.productGroupLoader = this.querySelector('[data-product-group-loader]');

        // If the element is there load the buttons first
        if(this.productGroupLoader) {
          this.fetchProductButtons();
        } else {
          this.addEvents();
        }

      }

      /**
       * addEvents
       * Looks for buttons and attach EventListeners
       */
      addEvents() {
        this.productGroupButtons = this.querySelectorAll('[data-product-group]');
        this.productGroupButtons?.forEach((button) => {
          button.addEventListener('click', event => this.handleProductGroupSwitch(event));
        });
      }

      /**
       * fetchProductButtons
       */
      async fetchProductButtons() {
        const productGroupTag = this.productGroupLoader.dataset.productGroupTag.replaceAll(': ', ':');
        const productGroupCollection = this.productGroupLoader.dataset.productGroupCollection;
        const productCurrentHandle = this.productGroupLoader.dataset.productCurrentHandle;
        const html = await fetch(`/collections/${productGroupCollection}/${productGroupTag}?section_id=product-card-tagged-group`)
          .then(response => {
            if(response.ok) {
              return response.text()
            } else {
              throw new Error('Something went wrong!');
            }
          })
          .then(data => {
            return data;
          })
          .catch((error) => {
            console.error(error);
          });

        if(html) {
          // Parse from string
          const productButtons = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-product-card-tagged-group');
          // Add html to parent
          this.productGroupLoader.appendChild(productButtons);
          // Set active state button based on current product handle
          const selectActiveVariant = this.querySelector(`[data-product-handle="${productCurrentHandle}"]`);
          if(selectActiveVariant) {
            selectActiveVariant.classList.add('product-from-same-group__button--active');
          }
        }

        // Attach events to injected html
        this.addEvents();

      }

      /**
       * handleProductGroupSwitch
       * @param {Object} event
       */
      async handleProductGroupSwitch(event) {

        // Get data from attribute
        const options = JSON.parse(event.currentTarget.dataset.options);

        // Guard
        if(!options) return;

        // Lock and update button state
        this.productGroupButtons?.forEach(button => {
          button.setAttribute('disabled', true);
          button.classList.remove('product-from-same-group__button--active');
        });

        const quickShopOptions = this.querySelectorAll('[data-quick-shop-option]');
        quickShopOptions?.forEach(option => option.setAttribute('disabled', true));

        event.currentTarget.classList.add('product-from-same-group__button--active');

        // this.productWishlist.setAttribute('data-variant', options.variantId);
        // this.productWishlist.setAttribute('data-product', options.productId);
        // Hide the wish list when you change a product
        if(this.productWishlist.dataset.product == options.productId) {
          this.productWishlist.classList.remove('hidden');
        } else {
          this.productWishlist.classList.add('hidden');
        }

        // Update url, text labels and price values
        this.productUrls?.forEach(url => url.href = options.url);
        this.productTitles?.forEach(title => title.innerHTML = options.title);
        this.productShortDescriptions?.forEach(description => description.innerHTML = options.short_description);
        this.productPrices?.forEach(price => price.innerHTML = options.price);
        if(parseInt(options.compare_at_price_max) !== 0) {
          this.productCompareAtPricesMax?.forEach(compareAtPriceMax => {
            compareAtPriceMax.innerHTML = options.compare_at_price_max;
            compareAtPriceMax.classList.remove('hidden');
          });
        } else {
          this.productCompareAtPricesMax?.forEach(compareAtPriceMax => {
            compareAtPriceMax.classList.add('hidden');
          });
        }

        // Update image
        const image = this.productFeaturedImage.querySelector('img');
        const sources = this.productFeaturedImage.querySelectorAll('source');

        image.src = options.featured_image;
        image.srcset = options.featured_image;
        image.alt = options.title;
        sources.forEach(source => {
          source.srcset = options.featured_image;
        });

        // Fetch data
        const data = await fetch(`${options.url}/?sections=product-card-form`).then(response => response.json());
        this.querySelector('.quick-shop__holder').innerHTML = new DOMParser().parseFromString(data['product-card-form'], 'text/html').querySelector('#shopify-section-product-card-form').innerHTML;

        // Unlock the group buttons so we can change again
        this.productGroupButtons?.forEach(button => button.removeAttribute('disabled'));
        
      }

    }

    window.ProductCard = ProductCard;

    customElements.define('product-card', ProductCard);

  }

})();
